module.exports = __webpack_public_path__ + "static/about_us_story-5f9db2ffcd5b236d21a8fdb59b0754d8.jpg";